import * as microsoftTeams from "@microsoft/teams-js";
import ErrorOr from "shared/ErrorOr";
import defaultAxiosClient from "shared/service/api";
import { AzureTokenRequest, AzureTokenResponse } from "./contracts";

class AzureTokenService {
    async tryGetUserToken(): Promise<ErrorOr<AzureTokenResponse>> {
        try {
            const request: AzureTokenRequest = {
                assertion: await microsoftTeams.authentication.getAuthToken(),
                scopeList: ["User.Read.All", "Presence.Read.All"],
            };
            const response = await defaultAxiosClient.post<AzureTokenResponse>("/secured/user/azure/token", request);
            return ErrorOr.Success<AzureTokenResponse>(response.data);
        } catch {
            return ErrorOr.Failed<AzureTokenResponse>(new Error("Failed to fetch user Azure token."));
        }
    }
}

export default new AzureTokenService();
